import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import logo from "./../../../assets/images/logo.png";
import { Button } from "@mui/material";
import "./most-popular-courses-navbar.css";
import { useNavigate } from "react-router-dom";
let MostPopularCoursesNavbar = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <div className="main-appbar-container">
            <div className="main-appbar-content-wraper">
              <Button variant="text">
                <img
                  src={logo}
                  alt="logo"
                  className="most-popular-courses-navbar-logo"
                />
              </Button>

              <div>
                <Button
                  variant="text"
                  className="most-popular-courses-navbar-button"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  login
                </Button>
                <Button
                  className="most-popular-courses-navbar-button"
                  variant="text"
                  onClick={() => {
                    navigate("/register");
                  }}
                >
                  register
                </Button>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default MostPopularCoursesNavbar;
